import { createSelector } from 'reselect';

const selectSubscriptions = (state: any) => state.subscriptions;


export const selectSubscriptionsCurrentItem = createSelector([selectSubscriptions], (subscriptions) => subscriptions.current);

export const selectSubscriptionsListItems = createSelector([selectSubscriptions], (subscriptions) => subscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectSubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSubscriptionsQueryItems = createSelector([selectSubscriptions], (subscriptions) => subscriptions.query);

export const selectSubscriptionsCreatedItem = createSelector([selectSubscriptions], (subscriptions) => subscriptions.create);

export const selectSubscriptionsUpdatedItem = createSelector([selectSubscriptions], (subscriptions) => subscriptions.update);

export const selectSubscriptionsReadItem = createSelector([selectSubscriptions], (subscriptions) => subscriptions.read);

export const selectSubscriptionsDeletedItem = createSelector([selectSubscriptions], (subscriptions) => subscriptions.delete);

export const selectSubscriptionsSearchedItems = createSelector([selectSubscriptions], (subscriptions) => subscriptions.search);

export const selectSubscriptionsItemsCount = createSelector([selectSubscriptions], (subscriptions) => subscriptions.count);

export const selectSubscriptionsItemsFilter = createSelector([selectSubscriptions], (subscriptions) => subscriptions.filter);